import { render } from "./FirstPage.vue?vue&type=template&id=3b1738a8"
import script from "./FirstPage.vue?vue&type=script&lang=js"
export * from "./FirstPage.vue?vue&type=script&lang=js"

import "./FirstPage.vue?vue&type=style&index=0&id=3b1738a8&lang=scss"
import "./FirstPage.vue?vue&type=style&index=1&id=3b1738a8&lang=css"
script.render = render

export default script